import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { TweenMax } from 'gsap';
import { sectionBefore } from '../../../actions/section';
import { shadowSize } from '../../../utils/utils';

export class Before extends React.Component {
	onClick(e) {
		const pics = $('#before-pics');
		$('.before-btn').each(function() {
			let el = $(this),
				elID = el.attr('id');
			if (el.attr('id') === e.target.id) {
				el.addClass('is-active');
				pics.children('#' + elID).addClass('is-active');
			} else {
				el.removeClass('is-active');
				pics.children('#' + elID).removeClass('is-active');
			}
		});
	}
	componentDidMount() {
		this.props.sectionBefore();
		setTimeout(function() {
			shadowSize();
		}, 100);
	}
	render() {
        return (
			<div id="before" className="panel">
				<div id="before-nav">
					<div id="posture" className="before-btn is-active" onClick={this.onClick}></div>
					<div id="paper" className="before-btn" onClick={this.onClick}></div>
					<div id="pencil" className="before-btn" onClick={this.onClick}></div>
				</div>
				<div id="before-pics">
					<div id="posture" className="before-pic is-active"></div>
					<div id="paper" className="before-pic"></div>
					<div id="pencil" className="before-pic"></div>
				</div>
			</div>
		);
    }
};

const mapDispatchToProps = (dispatch) => ({
	sectionBefore: () => dispatch(sectionBefore())
});

export default connect(undefined, mapDispatchToProps)(Before);



// WEBPACK FOOTER //
// ./src/components/sections/before/Before.js